<template>
  <el-col
    :span="24"
    id="check_processing"
    v-loading.body="showLoader"
    element-loading-text="Fetching page...">
    <el-row type="flex" justify="start" align="middle" id="check_processing-header">
      <HeaderInfoText :colspan="9" title="PAYMENT PROCESSING" :meta="meta" :selection="selection" />
      <el-col :span="6">
        <el-row type="flex" justify="center" v-if="meta.count > 20">
          <el-pagination
            layout="prev, pager, next, jumper"
            :total="meta.count"
            :page-size="20"
            @current-change="changePage"
            :current-page="currentPage"
          />
        </el-row>
      </el-col>
      <el-col :span="9" class="h-padded right-aligned-col">
        <el-row type="flex" justify="end" align="middle" style="padding: 0 12px;">
          <el-button
            type="danger"
            @click="confirmSignatureDialog = true"
            :disabled="!printableApsSelected || checkPrinterVisible || requestSignatureVisible"
            :loading="fetchingCheckData">
            {{ fetchingCheckData ? 'Fetching data' : 'Request Signature' }}
          </el-button>
          <el-button
            type="primary"
            @click="printChecks"
            :disabled="!printableApsSelected || checkPrinterVisible"
            :loading="fetchingCheckData">
            {{ fetchingCheckData ? 'Fetching data' : 'Process Selected Payments' }}
          </el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" justify="left" align="middle" style="padding: 0 12px;">
      <Filters
        :filters="filters"
        :filtersVisible="true"
        :filterSize="5"
        :applyDisabled="filteringShouldBeDisabled"
        :autoApply="false"
        clearAction="clearApState"
        clearMetadataAction="resetApMeta"
        searchAction="fetchPaymentsApsWithQuery"
        ref="printablesFilter"
        @applied="handleSelectionChange([])"
        @filterChanged="handleFilterChange"
        @filterCleared="() => changePage(1)">
        <template v-for="(f, i) in filters" slot-scope="props" :slot="`${f.type}${i}`">
          <component :ref="`${f.props.filterName}_filter`" :key="i" :is="f.type" :properties="f.props" />
        </template>
      </Filters>
    </el-row>
    <el-row type="flex" justify="end" align="middle">
      <el-col :span="24">
        <TransactionsConfList v-if="transactions" name="payment_processing_conf_list" ref="payment_conf_list" :aggridColumns="aggridColumns"
          :rows="transactions" :emitSelect="true" @onSelect="handleSelectionChange" :currentPage="currentPage"/>
      </el-col>
    </el-row>
    <el-row type="flex" justify="end" align="middle" v-if="showApprovalTable">
      <el-col :span="24">
        <el-row>
          <el-col :span="8">
            <el-row>
              <h2 class="mt-3 mb-2 ml-2">Checks For Signature Approval</h2>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row type="flex" justify="center" v-if="numPrintableDraftChecks > 20">
              <el-pagination
                layout="prev, pager, next, jumper"
                :total="numPrintableDraftChecks"
                :page-size="20"
                @current-change="changeDraftCheckPage"
                :current-page="currentDraftCheckPage"
              />
            </el-row>
          </el-col>
          <el-col :span="16">
            <el-row type="flex" justify="end">
              <el-button
              class="mr-4 mb-2 mt-3"
              type="primary"
              @click="loadDraftChecks(selectedBank)"
              >Refresh</el-button>
            </el-row>
          </el-col>
        </el-row>
        <TransactionsConfList v-if="draftChecks" name="draftChecks_transactions_conf_list" ref="draftChecks_conf_list" :aggridColumns="draftAggridColumns"
          :rows="draftChecks" :emitSelect="true" @onSelect="draftCheckSelectionChange" :currentPage="currentPage"/>
      </el-col>
    </el-row>
    <CheckPrinter
      v-if="getPaymentType === 'CHECK'"
      :checksToPrint="getCheckrunQuote"
      :selectedBank.sync="selectedBank"
      :postedChecks.sync="postedChecks"
      :getNumOfChecksToPrintPerBank="getNumOfChecksToPrintPerBank"
      :checkPrinterVisible.sync="checkPrinterVisible"
      :draft-checks="selectedDraftChecks"
      :paymentType="getPaymentType"
      @updatePostedChecks="updatePostedChecks"
      @resetParentFields="resetParentFields"
    />
    <PaymentPrinter
      v-else
      :checksToPrint="getCheckrunQuote"
      :selectedBank.sync="selectedBank"
      :postedChecks.sync="postedChecks"
      :getNumOfChecksToPrintPerBank="getNumOfChecksToPrintPerBank"
      :checkPrinterVisible.sync="checkPrinterVisible"
      :draft-checks="selectedDraftChecks"
      :paymentType="getPaymentType"
      :startingPaymentConfNumber="startingPaymentConfNumber"
      @updatePostedChecks="updatePostedChecks"
      @resetParentFields="resetParentFields"
    /> 
    <el-dialog
      title="Confirm Signature"
      :visible="confirmSignatureDialog"
      size="tiny"
      :show-close="false"
      :close-on-press-escape="true"
      :close-on-click-modal="false">
      <span>
        Are you sure you want to request digital signatures for the selected checks?
      </span>
      <div>
        <span>
        Number of signatures:
      </span>
      <select
      v-model="numberOfSignatures">
        <option>1</option>
        <option>2</option>
      </select>
      </div>
      <div v-for="signature in numberOfSignatures" :key="signature">
        <label for="`signatureSelect${signature}`">Signature {{ signature }}: </label>
        <select @change="selectSignatureUser($event, signature)" name="`signatureSelect${signature}`">
          <option v-for="option in signatureUserChoices" :value="option.userId" :key="option"> {{ option.text }} </option>
        </select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="exit-modal-btn" type="primary" @click="confirmSignatureDialog = false">
          No
        </el-button>
        <el-button class="exit-modal-btn" type="primary" @click="requestSignatureApprovals">
          Yes
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="eftDialogVisible"
      size="large"
      :show-close="true"
      :close-on-press-escape="true"
      :close-on-click-modal="false"
      @close="finishPayment">
      <NachaExport v-if="eftDialogVisible" :paymentBank="selectedBank" :paymentLines="selection" :startingPaymentConfNumber="startingPaymentConfNumber" @finishPayment="finishPayment"/>
    </el-dialog>
  </el-col>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { notify } from '@/utils/helpers/Notify'
  import store from '@/store/store'
  import PaymentPrinter from '@/components/Programs/PaymentProcessing/PaymentPrinter.vue'
  import CheckPrinter from '@/components/Programs/CheckProcessing/CheckPrinter.vue'
  import Filters from '@/components/Filters.vue'
  import SelectFilter from '@/components/FilterComponents/SelectFilter'
  import AutocompleteFilter from '@/components/FilterComponents/AutocompleteFilter.vue'
  import HeaderInfoText from '@/components/HeaderInfoText'
  import { capitalizeFirstLetter } from '@/utils/helpers/StringOperations'
  import { handleSelectionChange } from '@/components/RouteComponents/commonFunctions'
  import { formatLocale } from '@/utils/helpers/StringsNumbers'
  import { DataLoader } from '@/utils/helpers/DataLoader/DataLoader'
  import { payload as bankActionPayload } from '@/components/RouteComponents/Banks/actionPayload'
  import { payload as batchActionPayload } from '@/components/RouteComponents/Batches/actionPayload'
  import BaseResource from '@sigmacloud/sigma-client/dist/resources/base'
  import BatchResource from '@sigmacloud/sigma-client/dist/resources/transactions/batch'
  import UserResource from '@sigmacloud/sigma-client/dist/resources/user'
  import BankResource from '@sigmacloud/sigma-client/dist/resources/system/bank'
  import CheckResource from '@sigmacloud/sigma-client/dist/resources/transactions/check'
  import VendorResource from '@sigmacloud/sigma-client/dist/resources/system/vendor'
  import NachaExport from '@/components/Programs/NachaExport.vue'
  import TransactionsConfList from '@/components/SigmaClientNew/TransactionsConfList.vue'

  export default {
    components: {
      PaymentPrinter,
      CheckPrinter,
      Filters,
      SelectFilter,
      AutocompleteFilter,
      HeaderInfoText,
      NachaExport,
      TransactionsConfList
    },
    data () {
      return {
        tableHeight: 1000,
        batchUpdateSelection: null,
        selection: [],
        transactionsShown: [],
        loadingOptions: false,
        options: [],
        searchTimeout: null,
        checkPrinterVisible: false,
        selectedBank: null,
        postedChecks: [],
        fetchingCheckData: false,
        changingPage: false,
        receiving: false,
        loadingBatchOptions: false,
        confirmSignatureDialog: false,
        numberOfSignatures: 1,
        signatureUsers: [],
        signatureUserChoices: [],
        signatureUser1: undefined,
        signatureUser2: undefined,
        currentUser: undefined,
        draftChecks: [],
        selectedDraftChecks: [],
        draftChecktableKey: 0,
        draftChecksSelected: false,
        printableDraftCheckResource: undefined,
        numPrintableDraftChecks: 0,
        currentDraftCheckPage: 1,
        draftChecksLoading: false,
        eftDialogVisible: false,
        startingPaymentConfNumber: '',
        aggridColumns: ['rowSelect', 'ledgerColumn', 'numberColumn', 'vendorColumn', 'descriptionColumn', 'paymentTypeColumn', 'amountColumn', 'dueDateColumn', 'batchColumn', 'bankColumn'],
        draftAggridColumns: ['rowSelect', 'ledgerColumn', 'numberColumn', 'vendorColumn', 'descriptionColumn', 'amountColumn', 'batchColumn', 'signatureApprovalsColumn']
      }
    },
    methods: {
      /**
       * Handles transaction selection
       * @param selection
       */
      handleSelectionChange (selection) {
        this.$store.commit('SET_SELECTION', selection)
        const duplicatePaymentTypes = [...new Set(selection.map(s => s.payment_type))]
        if (selection && selection.length && duplicatePaymentTypes && duplicatePaymentTypes.length > 1) {
          return notify(this, 'error', 'Please select same Payment Type')
        }
        handleSelectionChange(this, selection)
      },
      draftCheckSelectionChange (selection) {
        this.selectedDraftChecks = selection
        if (this.selectedDraftChecks.length) {
          this.draftChecksSelected = true
        } else {
          this.draftChecksSelected = false
        }
      },
      /**
       * Handles paginating between PC pages
       * @param page  Target page
       */
      async changePage (page) {
        this.changingPage = true
        this.receiving = true
        try {
          if (!(this.currentFilters.batch__bank || this.currentFilters.batch)) {
            await this.setDefaultBank()
          }
          await this.$store.dispatch('clearApState', [])
          const entities = await this.$store.dispatch('fetchPaymentsApsWithQuery', { ...this.currentFilters, page })
          const promises = await this.$store.dispatch('findDependencies', entities)
          await Promise.all(promises)
          await new Promise((resolve, reject) => {
            setTimeout(() => {
              this.changingPage = false
              this.receiving = false
              resolve()
            })
          })
          this.restoreSelection()
        } catch (e) {
          console.log(e)
          this.changingPage = false
        }
      },
      async changeDraftCheckPage (page) {
        this.draftChecksLoading = true
        let requestedPage = await this.printableDraftCheckResource.get({params: {batch__bank: this.selectedBank, page: page}})
        let { data } = requestedPage
        this.draftChecks = data.results
        for (let result of this.draftChecks) {
          let batch = await BatchResource.detail(result.batch)
          result.batch = batch._attributes
          result.batchName = batch._attributes.name
          let vendor = await VendorResource.detail(result.vendor)
          result.vendorObj = vendor._attributes
        }
        this.draftChecktableKey++
        this.draftChecksLoading = false
      },
      /**
       * Preserves the selected transactions and shows them as selected whenever the table is re-rendered
       * due to a page or tab change
       */
      restoreSelection () {
        this.$refs['payment_conf_list'].restoreSelection(this.selection)
      },
      async loadDraftChecks (selectedBank) {
        let bankId = this.currentFilters.batch__bank
        if (selectedBank) {
          bankId = selectedBank
        }
        this.draftChecksLoading = true
        let printableCheckResource = CheckResource.wrap('/printable')
        let printableCheckResponse = await printableCheckResource.get({params: {batch__bank: bankId}})
        this.printableDraftCheckResource = printableCheckResource
        let { data } = printableCheckResponse
        this.numPrintableDraftChecks = data.count
        this.draftChecks = data.results
        for (let result of data.results) {
          let batch = await BatchResource.detail(result.batch)
          result.batch = batch._attributes
          let vendor = await VendorResource.detail(result.vendor)
          result.vendorObj = vendor._attributes
        }
        this.draftChecktableKey++
        this.draftChecksLoading = false
      },
      /**
       * Sets selected banks, grabs a check run quote, fetches starting check numbers, and
       * starts the check printer program
       */
      printChecks () {
        this.selectedBank = this.currentFilters.batch__bank
        if (this.selectedDraftChecks.length && !this.selection.length) {
          this.fetchingCheckData = false
          this.checkPrinterVisible = true
          return
        }
        if (this.selection[0].payment_type === 'EFT') {
          this.fetchStartingPaymentNumber(this.selection[0].batch)
        }
        if (this.selection && this.selection.length && this.selection[0].payment_type === 'EFT' && this.achEnabled) {
          this.eftDialogVisible = true
          return
        }
        let ids = this.selection.map(v => v.id)
        this.fetchingCheckData = true
        let fetch = this.selection[0].payment_type === 'CHECK' ? 'fetchCheckrunQuote' : 'fetchPaymentrunQuote'
        this.$store.dispatch(fetch, ids)
          .then(r => {
            if (!r) return notify(this, 'error', 'Error fetching check run quote')
            return this.fetchStartingCheckNumbers()
          })
          .then(() => {
            this.fetchingCheckData = false
            this.checkPrinterVisible = true
          })
          .catch(e => {
            notify(this, 'error', e && e.statusText ? e.statusText : 'Error starting check printer program')
            this.fetchingCheckData = false
          })
      },
      async getSignatureUsers () {
        let signatureResource = BaseResource.wrap('/signatures')
        let signatureResponse = await signatureResource.get({ params: { page_size: 100 } })
        let { data } = signatureResponse
        let { results } = data
        let signatureUserIds = []
        let signatureUserResources = []
        let userChoices = [{ userId: undefined, signatureId: undefined, text: '-' }]
        for (let result of results) {
          signatureUserIds.push(result.user)
        }
        for (let userId of signatureUserIds) {
          let userResource = await UserResource.detail(userId)
          signatureUserResources.push(userResource)
        }
        this.signatureUsers = signatureUserResources
        for (let userResource of signatureUserResources) {
          let signature = results.find((result) => {
            return result.user === userResource.id
          })
          let choice = {
            userId: userResource.id,
            signatureId: signature.id,
            text: `${userResource.attributes.first_name} ${userResource.attributes.last_name} - ${userResource.attributes.username} - ${userResource.attributes.email}`
          }
          if (userResource.id === this.currentUser) {
            choice.text += ' (myself)'
          }
          userChoices.push(choice)
        }
        this.signatureUserChoices = userChoices
      },
      selectSignatureUser (event, signature) {
        this[`signatureUser${signature}`] = parseInt(event.target.value)
      },
      getCurrentUser () {
        let userId = this.$store.getters.getUser.userId
        this.currentUser = userId
      },
      async requestSignatureApprovals () {
        let signatureChoices = {
          choice1: undefined,
          choice2: undefined
        }
        if (this.signatureUser1) {
          let choice = this.signatureUserChoices.find((choice) => {
            return choice.userId === this.signatureUser1
          })
          signatureChoices.choice1 = choice
        }
        if (this.signatureUser2) {
          let choice = this.signatureUserChoices.find((choice) => {
            return choice.userId === this.signatureUser2
          })
          signatureChoices.choice2 = choice
        }
        let choiceNames = Object.keys(signatureChoices)
        for (let choice of choiceNames) {
          if (signatureChoices[choice] !== undefined) {
            // choice contains userId and signatureId
            // need to generate checks from selection

            // Step 1: Fetch quotes - need AP ids
            let selectedAps = []
            for (let ap of this.selection) {
              selectedAps.push(ap.id)
            }
            let queryUrlString = '/runs/quote?ap__id__in='
            for (let ap of selectedAps) {
              queryUrlString += `${ap},`
            }
            let cleanedUrlString = queryUrlString.substring(0, queryUrlString.length - 1)
            let checkRunQuoteResource = BaseResource.wrap(cleanedUrlString)
            let checkRunQuoteResponse = await checkRunQuoteResource.get()
            let checkRunQuotes = []
            for (let quote of checkRunQuoteResponse.data) {
              checkRunQuotes.push(quote)
            }

            // Step 2: Save batches
            let quotesWithBatches = await this.saveBatches(checkRunQuotes)
            let reFlattenedQuotes = []
            let apIds = Object.keys(quotesWithBatches)
            for (let apId of apIds) {
              reFlattenedQuotes.push(...quotesWithBatches[apId])
            }

            // Step 3: Organize quotes by bank
            let quoteByBanks = {}
            for (let quote of reFlattenedQuotes) {
              quoteByBanks[`${quote.batch.bank}`] = [quote]
            }

            // Step 4: Assign numbers to checks
            let numberedChecks = await this.getCheckNumbers(quoteByBanks)

            // Step 5: Save checks
            let savedChecks = await this.saveChecks(numberedChecks)

            // Step 6:  POST new signature requests with check numbers
            let signatureRequestPayload = {
              paper_check: undefined,
              signature: signatureChoices[choice].signatureId,
              requested_by: this.currentUser,
              requested_user: signatureChoices[choice].userId,
              request_type: 'SIGNATURE'
            }

            for (let check of savedChecks) {
              signatureRequestPayload.paper_check = check.id
              let signatureRequestResource = BaseResource.wrap('/checkapprovals')
              await signatureRequestResource.post(signatureRequestPayload)
            }
          }
        }
        notify(this, 'success', 'Your check signature request has been sent to the specified signer(s)')
        this.confirmSignatureDialog = false
      },
      async saveBatches (quotedChecks) {
        // Group quotes by AP
        let groupedQuotes = {}
        for (let quote of quotedChecks) {
          let apId = quote.related_transactions[0].id
          if (groupedQuotes[apId]) {
            groupedQuotes[apId].push(quote)
          } else {
            groupedQuotes[apId] = [quote]
          }
        }
        // Quotes are grouped by AP
        // Need to create one batch per AP, then assign the resulting id to the existing check quotes
        let apIds = Object.keys(groupedQuotes)
        for (let apId of apIds) {
          let batchResource = new BatchResource()
          let batchData = groupedQuotes[apId][0].batch
          let batchKeys = Object.keys(batchData)
          for (let key of batchKeys) {
            batchResource.set(key, batchData[key])
          }
          await batchResource.save()

          for (let ap of groupedQuotes[apId]) {
            ap.batch.id = batchResource.id
          }
        }

        return groupedQuotes
      },
      async getCheckNumbers (groupedPayrolls) {
        let bankIds = Object.keys(groupedPayrolls)
        let quotedChecks = []
        for (let bankId of bankIds) {
          let numChecks = groupedPayrolls[bankId].length

          let bankRes = BankResource.wrap(`/${bankId}/checks?amount=${numChecks}`)
          let { data } = await bankRes.get()
          for (let index = 0; index < numChecks; index++) {
            groupedPayrolls[bankId][index].number = String(data[index])
          }
          quotedChecks.push(...groupedPayrolls[bankId])
        }
        return quotedChecks
      },
      async saveChecks (checkData) {
        let checks = []
        let savedChecks = []
        for (let check of checkData) {
          let newCheckResource = new CheckResource()
          for (let attribute of Object.keys(check)) {
            newCheckResource.set(attribute, check[attribute])
          }
          newCheckResource.set('status', 'DRAFT')
          checks.push(newCheckResource)
        }
        for (let check of checks) {
          await check.save()
          savedChecks.push(check)
        }
        return savedChecks
      },

      /**
       * Sets selected banks, grabs a check run quote, fetches starting check numbers, and
       * starts the check printer program
       */
      signChecks () {
        this.confirmSignatureDialog = false
        this.selectedBank = this.currentFilters.batch__bank
        // let ids = this.selection.map(v => v.id)

        // Do new work here to create/modify check runs with signature requests/signatures
        // console.log.log(ids) // placeholder

        // if (checks are updated successfully)
        notify(this, 'success', 'Checks will contain your signature.  Please click on "Print Selected Checks" when ready.')
        // else do something else
      },
      /**
       * Fetches starting check numbers
       * @return {Promise.<*[]>}
       */
      fetchStartingPaymentNumber (batch) {
        let paymentNumberResource = BaseResource.wrap(`/batches/${batch}/fetch_auto_payment_number`)
        paymentNumberResource.post({ payment_type: this.getPaymentType })
          .then(response => {
            this.startingPaymentConfNumber = response.data.payment_number
          })
          .catch(error => {
            console.log(error)
            return error
          })
      },
      /**
       * Fetches starting check numbers
       * @return {Promise.<*[]>}
       */
      async fetchStartingCheckNumbers () {
        try {
          const amount = this.getNumOfChecksToPrintPerBank()[this.selectedBank]
          const resp = await this.$store.dispatch('fetchCheckNumbers', { id: this.selectedBank, params: { amount } })
          if (!resp) {
            throw new Error('Unable to fetch check numbers')
          }
        } catch (e) {
          console.log(e)
        }
      },
      /**
       * Calculates the number of checks to print per bank, based on how many times a specific bank
       * is referenced across all selected APs
       * @return {{}}   An object containing the bank id as the property and frequency as its value
       */
      getNumOfChecksToPrintPerBank () {
        let ret = {}
        this.getCheckrunQuote.forEach(check => {
          const bankId = check.batch.bank
          if (!ret[bankId]) {
            ret[bankId] = 1
          } else {
            ret[bankId]++
          }
        })
        return ret
      },
      /**
       * Updates the list of available checks after one or more checks have been posted
       */
      updatePostedChecks (newData) {
        this.postedChecks = newData
        this.refreshData()
      },
      /**
       * Resets certain fields after checks print or after user cancels check printing
       */
      resetParentFields () {
        this.selection = []
        if (this.selectedDraftChecks.length) {
          this.$refs.draftChecks_conf_list.deselectAll()
        }
        this.$store.dispatch('clearCheckNumbers')
        this.checkPrinterVisible = false
        this.selectedBank = null
      },
      /**
       * Refreshes the list of APs after one or more checks have been posted. First, clears stale data, then gets the
       * batches which belong to the currently selected bank. Then, fetches printable APs, preserving any existing
       * filter criteria.
       */
      async refreshData () {
        this.receiving = true
        try {
          let batchPayload = Object.assign({}, batchActionPayload, { query: { bank: this.currentFilters.batch__bank, active: 'True' } })
          const dataLoader = new DataLoader(this.$store, [ batchPayload ])
          let initPromises = [
            this.$store.dispatch('clearApState', true),
            this.$store.dispatch('clearBatchState', true),
            this.$store.dispatch('clearVendorState'),
            dataLoader.loadData()
          ]
          await Promise.all(initPromises)
          const entities = await this.$store.dispatch('fetchPaymentsApsWithQuery', this.currentFilters)
          let promises = await this.$store.dispatch('findDependencies', entities)
          if (Array.isArray(promises)) {
            promises.push(this.$store.dispatch('fetchCurrentAndNextPeriod'))
          }
          await Promise.all(promises)
          this.transactionsShown = this.transactions
        } catch (e) {
          console.log(e)
          notify(this, 'warning', 'Failed to refresh data')
        } finally {
          this.receiving = false
        }
      },
      /**
       * Sets the default bank in bank filter
       */
      async setDefaultBank () {
        if (this.getDefaultBank && Object.keys(this.getDefaultBank).length) {
          await this.$store.dispatch('setDefaultSelection', { bank: {
            label: this.getDefaultBank.name,
            value: this.getDefaultBank.id
          }})
        }
      },
      capitalizeFirstLetter,
      /**
       * Formats dollar amounts with thousands separators
       * @param value
       * @return {*}
       */
      formatAmount (value) {
        return value ? formatLocale(value) : ''
      },
      formatApprovalsColumn (value) {
        return value.signature_status
      },
      /**
       * Event handler that fires whenever the filters change. If the 'batch__bank' filter changes, clears the batch
       * options from the batch select filter, then fetches batches associated with the new 'batch__bank' value.
       * @param filterName  The name of the filter that changed
       * @param selectedVal The new value
       */
      async handleFilterChange ({ filterName = '', selectedVal = '' }) {
        try {
          if (filterName === 'batch__bank' && selectedVal !== this.currentFilters.batch__bank) {
            if (this.$refs.batch_filter && this.$refs.batch_filter[0] && this.$refs.batch_filter[0].hasOwnProperty('selectedVal')) {
              this.$refs.batch_filter[0].selectedVal = []
              this.$refs.batch_filter[0].change()
              await this.loadDraftChecks(selectedVal)
            }
            await Promise.all([this.$store.dispatch('clearBatchState', true), this.$store.dispatch('resetBatchMeta')])
            const newPayload = Object.assign({}, batchActionPayload, { query: { bank: selectedVal, active: 'True' } })
            const dataLoader = new DataLoader(this.$store, [ newPayload ])
            await dataLoader.loadData()
            await this.$store.dispatch('fetchPeriodsWithQuery', { active: 'True' })
          }
        } catch (e) {
          console.log('Failed to fetch new data after applying filters: ' + e)
        }
      },
      finishPayment () {
        this.eftDialogVisible = false
        this.updatePostedChecks([])
        this.resetParentFields()
        this.$store.commit('SET_SELECTION', [])
      }
    },
    computed: {
      ...mapGetters({
        transactions: 'getAps',
        getVendorById: 'getVendorById',
        batch: 'getBatchById',
        banks: 'getBanks',
        batches: 'getBatches',
        currentPage: 'getCurrentApPage',
        getDefaultBatch: 'getDefaultBatch',
        getDefaultBank: 'getDefaultBank',
        getBankById: 'getBankById',
        getBankByBatchId: 'getBankByBatchId',
        getCompanyByBatchId: 'getCompanyByBatchId',
        getCompanyById: 'getCompanyById',
        getCheckrunQuote: 'getCheckrunQuote',
        currentPeriod: 'getCurrentPeriod',
        meta: 'getApMetadata',
        navigating: 'getNavigationStatus',
        currentFilters: 'getFilters'
      }),
      /**
       * Retrieves all batches associated with the currently selected bank
       */
      batchFilterOptions () {
        if (this.currentFilters.batch__bank) {
          return this.$store.getters.getAllBatches
            .filter(batch => batch && batch.bank === this.currentFilters.batch__bank)
            .map(batch => ({ label: batch.name, value: batch.id }))
        }
        return []
      },
      /**
       * Available filters
       */
      filters () {
        return [
          {
            type: 'selectFilter',
            props: {
              filterName: 'batch__bank',
              filterable: true,
              clearable: false,
              opts: this.$store.getters.getAllBanks.map(bank => ({ label: bank.name, value: bank.id })),
              defaults: [this.getDefaultBank.id],
              multi: false,
              placeholder: 'Select a bank',
              applyOnSelection: true
            }
          },
          {
            type: 'selectFilter',
            props: {
              filterName: 'payment_type',
              clearable: true,
              opts: [
                { label: 'All', value: 'CHECK,WIRE,EFT,CHECK_MANUAL' },
                { label: 'Check', value: 'CHECK' },
                { label: 'Wire Transfer', value: 'WIRE' },
                { label: 'EFT', value: 'EFT' },
                { label: 'Manual Check', value: 'CHECK_MANUAL' }
              ],
              // defaults: [ 'CHECK', 'WIRE', 'EFT', 'CHECK_MANUAL' ],
              multi: true,
              placeholder: 'Payment Type'
            }
          },
          {
            type: 'autocompleteFilter',
            props: {
              filterName: 'batch',
              remote: true,
              clearable: true,
              action: 'fetchBatchesWithQuery',
              clearAction: 'clearBatchState',
              getter: 'getBatchesBySearchCriteria',
              triggerOnFocus: false,
              placeholder: 'Batch',
              queryParamType: 'search',
              suggestionLabelAttr: 'name'
            }
          },
          {
            type: 'autocompleteFilter',
            props: {
              filterName: 'vendor',
              remote: true,
              clearable: true,
              action: 'fetchVendorsWithQuery',
              clearAction: 'clearVendorState',
              getter: 'getVendorsBySearchCriteria',
              triggerOnFocus: false,
              placeholder: 'Vendor',
              queryParamType: 'search',
              suggestionLabelAttr: 'name'
            }
          }
        ]
      },
      /**
       * Returns a boolean indicating whether the filters' "Apply" button should be disabled. This is useful
       * because this particular view requires that all printable APs being displayed be from one bank, so the
       * user cannot be allowed to clear the filters and hit "Apply", because that could return printable APs
       * from multiple batches/banks.
       */
      filteringShouldBeDisabled () {
        return !this.currentFilters.batch && !this.currentFilters.batch__bank
      },
      /**
       * Returns a boolean indicating whether a selection was made. Used to enable/disable the "Print Selected Checks"
       * button.
       */
      printableApsSelected () {
        return (!!this.selection.length || !!this.selectedDraftChecks.length)
      },
      /**
       * Computed property that returns a boolean indicating whether the loading overlay should be shown
       */
      showLoader () {
        return (this.receiving || this.changingPage) && !this.navigating && !this.checkPrinterVisible
      },
      /**
       * Computed property that returns a boolean indicating whether the Request Signature button should be shown
       */
      requestSignatureVisible () {
        return !!this.selection.filter((s) => s.payment_type !== 'CHECK').length
      },
      getPaymentType () {
        return (this.selection && this.selection.length) ? this.selection[0].payment_type : 'CHECK'
      },
      achEnabled () {
        return !!this.$store.getters.getUiSettings['ACH_ENABLED']
      },
      showApprovalTable () {
        return this.currentFilters && this.currentFilters.payment_type__in && ['CHECK,WIRE,EFT,CHECK_MANUAL', 'CHECK'].some(i => this.currentFilters.payment_type__in.includes(i))
      }
    },
    watch: {
      transactions () {
        this.transactionsShown = this.transactions
      },
      numberOfSignatures (newValue) {
        if (typeof newValue === 'number') return
        this.numberOfSignatures = parseInt(newValue)
      }
    },
    /**
     * Pre-route enter logic. Clears AP, Batch, and Vendor state, fetches the active period,
     * fetches printable APs, then finds and fetches dependencies for printable APs.
     * Since the options in the batch filter are now dependent on the selected bank, and since the component must
     * initialize with results already filtered by default bank, then the active batches associated with the
     * default bank must also be fetched so that batch filter options are available once the component renders. This
     * is done after the initial set of printable APs has been fetched.
     * @param to
     * @param from
     * @param next
     */
    async beforeRouteEnter (to, from, next) {
      try {
        let dataLoader = new DataLoader(store, [ bankActionPayload ])
        const promises = [
          store.dispatch('clearApState', true),
          store.dispatch('clearBatchState'),
          store.dispatch('clearVendorState'),
          store.dispatch('fetchPeriodsWithQuery', { active: 'True' }),
          store.dispatch('fetchUiSetting', { name: 'CHECK_DATE_RANGE' }),
          dataLoader.loadData()
        ]
        await Promise.all(promises)
        // dataLoader = null
        // let entities
        const defaultBank = store.getters.getDefaultBank
        if (defaultBank && defaultBank.id) {
          const query = { batch__bank: defaultBank.id }
          await store.dispatch('setFilter', query)
          // entities = await store.dispatch('fetchPaymentsApsWithQuery', query)
          await store.dispatch('fetchPaymentsApsWithQuery', query)
          // const batchPayload = Object.assign({}, batchActionPayload, { query: { bank: defaultBank.id, active: 'True' } })
          // dataLoader = new DataLoader(store, [ batchPayload ])
        } else {
          await store.dispatch('fetchPaymentsApsWithQuery')
        }
      } catch (e) {
        console.log(e)
      } finally {
        next()
      }
    },
    async created () {
      this.setDefaultBank()
    },
    async beforeMount () {
      await this.loadDraftChecks()
    },
    async mounted () {
      this.$nextTick = () => {
        const tableHeight = () => {
          const parentHeight = document.getElementById('check_processing').offsetHeight
          const headerHeight = document.getElementById('check_processing-header').offsetHeight
          return parentHeight - headerHeight
        }
        this.tableHeight = tableHeight()
      }

      this.getCurrentUser()
      await this.getSignatureUsers()
    },
    /**
     * Pre-route leave housecleaning
     * @param to
     * @param from
     * @param next
     * @return {Promise<void>}
     */
    async beforeRouteLeave (to, from, next) {
      try {
        await Promise.all([
          this.$store.dispatch('clearFilters'),
          this.$store.dispatch('clearBatchState', true),
          this.$store.dispatch('clearVendorState', true),
          this.$store.dispatch('clearApState', true)
        ])
      } catch (e) {
        console.log(e)
      } finally {
        next()
      }
    }
  }
</script>

<style scoped>
  /*Input form table style properties*/
  table {
    border-spacing: 0;
    border: 1px solid #bfcbd9;
    background-color: #efefef;
  }
  /*Table style properties*/
  .h-padded {
    padding: 0 12px;
  }
  .v-padded-s {
    padding: 12px 0;
  }
  .left-aligned-col {
    text-align: left;
  }
  #check_processing-header {
    border-bottom: 1px solid lightgray;
  }
  .el-table .modified-row {
    background: #c9e5f5;
  }
</style>



// WEBPACK FOOTER //
// src/components/Programs/PaymentProcessing/PaymentProcessing.vue